import { useHistory } from 'react-router-dom'

import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Button, Layout } from '@loadsmart/miranda-react'

import { EmptyStateWrapper } from './EmptyState.styles'

export function EmptyShipmentsListState() {
  const history = useHistory()

  function handleBookClick() {
    history.push('/loads')
  }

  return (
    <EmptyStateWrapper>
      <Layout.Stack gap="spacing-4" align="center">
        <EmptyState title="You have no active shipments in your list" variant="page" />
        <Layout.Group>
          <Button type="button" variant="secondary" onClick={handleBookClick}>
            Book your first load
          </Button>
        </Layout.Group>
      </Layout.Stack>
    </EmptyStateWrapper>
  )
}
